// SearchResults.js
import React, { useContext } from "react";
import { SearchContext } from "./SearchContext";
import SupportResults from "./SupportResults";

const SearchResults = () => {
  const { data } = useContext(SearchContext);

  return <SupportResults data={data} />;
};

export default SearchResults;
